import { faSignalStream } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CopyableText } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IApiGetLiveStreamsItemResponseBody } from '~/lib/api/modules/LiveStreams';
import { ContentBlock } from '~/components/molecules/ContentBlock';

export type ILiveStreamStreamingProps = IContainerProps & {
  liveStream: IApiGetLiveStreamsItemResponseBody;
};

export const LiveStreamStreaming: React.FC<ILiveStreamStreamingProps> = (
  props,
) => {
  const { sx, liveStream } = props;
  const { t } = useTranslation();

  const ingestEndpointUrl = `rtmps://${liveStream?.ingestEndpoint}:443/apps/`;

  return (
    <ContentBlock sx={sx}>
      <ContentBlock.Title
        icon={<FontAwesomeIcon icon={faSignalStream} />}
        supportingText={t('LiveStreamStreaming.supportingText')}
      >
        {t('LiveStreamStreaming.title')}
      </ContentBlock.Title>

      <ContentBlock.InfoList>
        <ContentBlock.InfoListItem
          label={t('LiveStreamStreaming.fields.ingestEndpoint.label')}
        >
          <CopyableText>{ingestEndpointUrl}</CopyableText>
        </ContentBlock.InfoListItem>

        <ContentBlock.InfoListItem
          label={t('LiveStreamStreaming.fields.streamKey.label')}
        >
          <CopyableText>{liveStream.streamKey}</CopyableText>
        </ContentBlock.InfoListItem>
      </ContentBlock.InfoList>
    </ContentBlock>
  );
};
